export default [
  {
    path: '/user/activity',
    name: 'Users.User.Activity',
    component: () => import('@/views/User/Activity.vue'),
    meta: { title: 'Aktivitas Member', icon: 'fas fa-users fa-2x' },
  },
  {
    path: '/user/:uuid/detail',
    name: 'Users.User.Detail',
    component: () =>
      import(
        '@/views/User/Detail.vue'
      ),
    meta: {
      title: 'Detail User',
      icon: 'fas fa-users fa-2x'
    },
  },
  {
    path: '/user/add',
    name: 'Users.User.Add',
    component: () =>
        import(
            '@/views/User/Add.vue'
        ),
    meta: {
        title: 'Create User',
        icon: 'fas fa-users fa-2x',
    },
  },
  {
    path: '/user/:id/edit',
    name: 'Users.User.Form',
    component: () =>
      import(
        '@/views/User/Form.vue'
      ),
    meta: {
      title: 'Edit User',
      icon: 'fas fa-users fa-2x'
    },
  },
  {
    path: '/user/mentor',
    name: 'Users.Mentor.List',
    component: () =>
      import(
        '@/views/User/Mentor/List.vue'
      ),
    meta: {
      title: 'List Mentor',
      icon: 'fas fa-users fa-2x'
    },
  },
  {
    path: '/user/admin',
    name: 'Users.Admin.List',
    component: () =>
      import(
        '@/views/User/Admin/List.vue'
      ),
    meta: {
      title: 'List Admin',
      icon: 'fas fa-users fa-2x'
    },
  },
]
